import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Heading } from 'lmc-ui-library-rebrand';
import { login } from 'routes/routePaths';
import styled from 'styled-components';

interface Props {
  type?: 'set' | 'reset';
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Success: React.FC<Props> = ({ type = 'set' }) => {
  return (
    <Wrapper>
      <Heading weight="bold" mode="title" style={{ marginTop: 0 }}>
        Your password has now been {type === 'set' ? 'set' : 'reset'}
      </Heading>
      <Link to={login}>
        <Button borderVariant="rectangle" mode="primary" mt={4} mb={5}>
          Sign in
        </Button>
      </Link>
    </Wrapper>
  );
};

export default Success;
